"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const styled_components_1 = __importStar(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const config_1 = require("@completeanatomy/config");
const index_1 = require("../../atoms/index");
const index_2 = require("../../molecules/index");
const ActionButton_1 = __importDefault(require("../ActionButton"));
// eslint-disable-next-line max-lines-per-function
function Notification({ className, notification, isGroup, selected, onSelect, important = false, // TODO: remove this flag in future updates if necessary (after adding action buttons)
buttons, description, title, hasSelected = false, }) {
    var _a, _b;
    const { user, group, message, identifier } = notification;
    const { isMobile } = (0, device_1.usePlatform)();
    const config = (0, config_1.useConfigService)();
    const baseImageUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    const isPortableDevice = isMobile;
    let userAvatar;
    let groupAvatar;
    if (user === null || user === void 0 ? void 0 : user.avatar) {
        userAvatar = ((_a = user === null || user === void 0 ? void 0 : user.avatar) === null || _a === void 0 ? void 0 : _a.startsWith('http'))
            ? user === null || user === void 0 ? void 0 : user.avatar
            : baseImageUrl + (user === null || user === void 0 ? void 0 : user.avatar);
    }
    if (group === null || group === void 0 ? void 0 : group.avatar) {
        groupAvatar = ((_b = group === null || group === void 0 ? void 0 : group.avatar) === null || _b === void 0 ? void 0 : _b.startsWith('http'))
            ? group === null || group === void 0 ? void 0 : group.avatar
            : baseImageUrl + (group === null || group === void 0 ? void 0 : group.avatar);
    }
    const image = isGroup ? groupAvatar : userAvatar;
    const notificationTitle = title || (message === null || message === void 0 ? void 0 : message.name);
    const containerClassName = (0, classnames_1.default)({ important });
    const mobileCheckmarkIcon = (isPortableDevice && selected && ui_1.Icons.Checkmark) || null;
    return ((0, jsx_runtime_1.jsxs)(Container, { "$selected": selected, className: containerClassName, "data-e2e": 'Notification_Container', children: [(0, jsx_runtime_1.jsx)(ContentContainer, { "$important": important, "data-e2e": 'Notification_ContentContainer', children: (0, jsx_runtime_1.jsxs)(ContentWrapper, { "data-e2e": 'Notification_ContentWrapper', children: [!important && ((0, jsx_runtime_1.jsx)(index_1.NotificationCheckmark, { className: className, selected: selected, hasSelected: hasSelected, isPortableDevice: isPortableDevice, "data-e2e": 'Notification_NotificationCheckmark' })), (0, jsx_runtime_1.jsx)(AvatarContainer, { "data-e2e": 'Notification_AvatarContainer', children: (0, jsx_runtime_1.jsx)(ui_1.Avatar, { image: image, group: isGroup, userIcon: mobileCheckmarkIcon, style: { width: '40px', height: '40px' }, "data-e2e": 'Notification_Avatar' }) }), (0, jsx_runtime_1.jsx)(index_2.NotificationContent, { name: notificationTitle, onSelect: onSelect, className: className, identifier: identifier, important: important, description: description, "data-e2e": 'Notification_NotificationContent' })] }) }), (0, jsx_runtime_1.jsxs)(ButtonsWrapper, { "data-e2e": 'Notification_ButtonsWrapper', children: [!important && ((0, jsx_runtime_1.jsx)(index_2.ClearButton, { selected: selected, className: className, identifier: identifier, isPortableDevice: isPortableDevice, "data-e2e": 'Notification_ClearButton' })), important &&
                        (buttons === null || buttons === void 0 ? void 0 : buttons.map((button, index) => ((0, jsx_runtime_1.jsx)(ActionButton_1.default, { title: button.title, icon: button.icon, type: button.type, action: button.action, identifier: identifier, isLoading: button.isLoading, setLoading: button.setLoading, isSyncNotify: button.isSyncNotify, shouldDeleteOnAction: button.shouldDeleteOnAction, "data-e2e": 'Notification_ActionButton' }, index + identifier))))] })] }, notification.identifier));
}
const AvatarContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  min-height: 88px;
  margin-bottom: 4px;
  padding-left: 29px;

  background-color: ${({ $selected, theme }) => $selected
    ? theme.designSystem.contentBackground
    : theme.designSystem.background};

  &.important {
    padding-left: 24px;
    border-left: 5px solid ${({ theme }) => theme.greenSecondary};
    background-color: ${({ theme }) => theme.designSystem.contentBackground};

    &:has(+ :not(.important)) {
      margin-top: 0;

      ${ui_1.device.laptopS((0, styled_components_1.css) `
        border-bottom-left-radius: 4px;
      `)};
    }

    &:has(+ .important) {
      margin-bottom: 0;
    }

    &:first-child {
      ${ui_1.device.laptopS((0, styled_components_1.css) `
        border-top-left-radius: 4px;
      `)};
    }

    &:last-child {
      ${ui_1.device.laptopS((0, styled_components_1.css) `
        border-bottom-left-radius: 4px;
      `)};
    }

    ${ui_1.device.laptopS((0, styled_components_1.css) `
      margin-left: 35px;
      min-height: 64px;
    `)};
  }

  &:not(.important) + .important {
    ${ui_1.device.laptopS((0, styled_components_1.css) `
      border-top-left-radius: 4px;
    `)};
  }

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: row;
    justify-content: space-between;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    min-height: 64px;
    padding-left: 0;
    margin-left: 0;
    border-left: 0;
  `)};
`;
const ContentContainer = styled_components_1.default.div `
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin-left: 0;
  `)};
`;
const ContentWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
`;
const ButtonsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  padding-left: 50px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    justify-content: right;
    align-items: center;
    padding-left: 0;
  `)};
`;
exports.default = Notification;
